import * as React from 'react';
/**
 * @interface CardProps
 * @description Define las propiedades del componente Card.
 */
interface CardProps {
  /**
   * @property {React.ReactNode} children - Los hijos del componente Card.
   */
  children: React.ReactNode;
  /**
   * @property {string} className - La clase del componente Card.
   */
  className?: string;
  /**
   * @property {string} padding - El padding del componente Card. `none` deja el contenido llegar al
   * borde (listas, paneles divididos) y cada sección pone su propio relleno.
   */
  padding?: 'none' | 'sm' | 'md' | 'lg';
  /**
   * @property {string} shadow - El shadow del componente Card.
   */
  shadow?: 'sm' | 'md' | 'lg';
}

/**
 * @component Tarjeta
 * @description Un componente de tarjeta flexible con relleno y sombra personalizables.
 * @param {CardProps} props Las propiedades del componente.
 * @returns {React.ReactElement} El componente de tarjeta renderizado.
 */
export const Card: React.FC<CardProps> = ({
  children,
  className = '',
  padding = 'md',
  shadow = 'md',
}) => {
  const paddingClasses = {
    none: '',
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8',
  };

  const shadowClasses = {
    sm: 'shadow-sm',
    md: 'shadow-md',
    lg: 'shadow-lg',
  };

  return (
    <div
      className={`bg-background-primary rounded-lg border border-gray-200 ${paddingClasses[padding]} ${shadowClasses[shadow]} ${className}`}
    >
      {children}
    </div>
  );
};
